export const PAY_TYPE = {
  PAYMENT: 0,
  PAYOUT: 2,
};

export const PAY_METHOD = {
  BANK_CARD_1: 1,
  PLUS24_2: 2,
  BANK_CARD_3: 3,
  TERMINAL: 4,
  WEB_MONEY: 6,
  PLUS24_7: 7,
  QIWI: 7,
  BANK_CARD_9: 9,
  MOBILE: 10,
  GOOGLE_PAY: 15,
  APPLE_PAY: 16,
};

export const PAY_METHOD_WITH_TYPE = {
  [PAY_TYPE.PAYMENT]: {
    BANK_CARD_1: PAY_METHOD.BANK_CARD_1,
    PLUS24_2: PAY_METHOD.PLUS24_2,
    TERMINAL: PAY_METHOD.TERMINAL,
    WEB_MONEY: PAY_METHOD.WEB_MONEY,
    QIWI: PAY_METHOD.QIWI,
    BANK_CARD_9: PAY_METHOD.BANK_CARD_9,
    MOBILE: PAY_METHOD.MOBILE,
    GOOGLE_PAY: PAY_METHOD.GOOGLE_PAY,
  },
  [PAY_TYPE.PAYOUT]: {
    BANK_CARD_1: PAY_METHOD.BANK_CARD_1,
    BANK_CARD_3: PAY_METHOD.BANK_CARD_3,
    PLUS24_7: PAY_METHOD.PLUS24_7,
    MOBILE: PAY_METHOD.MOBILE,
    GOOGLE_PAY: PAY_METHOD.GOOGLE_PAY,
  },
};

export const ONLY_BANK_CARD_LIST = [
  PAY_METHOD.BANK_CARD_1,
  PAY_METHOD.BANK_CARD_3,
  PAY_METHOD.BANK_CARD_9,
];

export enum PaymentStatus {
  WAIT_PAYMENT = 1, // Ожидание платежа 1
  WAIT_PROCESSING = 11,
  WAIT_PAYMENT_CONFIRM = 12,
  WAIT_EXTERNAL_PAYSYSTEM = 13,
  HOLDED = 14,
  WAIT_AMOUNT_CONFIRM = 15,
  PAYMENT_SUCCESS = 2 /* Успешно 2 */,
  PAYMENT_REFUND = 21,
  PAYMENT_CANCEL = 22,

  // Платёж в ошибке
  PAYMENT_FAILED = 3,
  RETRYABLE_FAILED = 31,
  PAYMENT_TIMEOUT = 32,
  ANTIFROD_DECLINED = 33,

  // Платёж не найден
  PAYMENT_NOTFOUND = 4,

  // Ошибки внутренние
  INTERNAL_ERROR = 5,
  INCORRECT_DATA = 51,

  // Ошибки инвойсов
  INVOICE_DISABLED = 6,

  // Ошибки мерчанта
  MERCHANT_BLOCKED = 7,
}

export const InvoiceSteps = {
  ENTER_AMOUNT: 1,
  ENTER_CARD: 2,
};

export const ErrorStatuses = [
  PaymentStatus.INTERNAL_ERROR,
  PaymentStatus.INCORRECT_DATA,
  PaymentStatus.INVOICE_DISABLED,
  PaymentStatus.PAYMENT_FAILED,
  PaymentStatus.ANTIFROD_DECLINED,
  PaymentStatus.RETRYABLE_FAILED,
];
